import type { EndpointMeta } from "@/apis/types";
import {
  createFetchAndHook,
  type FetchFactory,
  type HookFactory,
} from "@/shared/factories";
import { wsdotHighwayAlertsApiMeta } from "../apiMeta";
import {
  type AlertByIdInput,
  alertByIdInputSchema,
} from "./shared/highwayAlerts.input";
import { type Alert, alertSchema } from "./shared/highwayAlerts.output";

/**
 * Metadata for the fetchAlertById endpoint
 */
export const alertByIdMeta = {
  functionName: "fetchAlertById",
  endpoint: "/getAlertAsJson?AlertID={AlertID}",
  inputSchema: alertByIdInputSchema,
  outputSchema: alertSchema,
  sampleParams: { AlertID: 468632 },
  endpointDescription: "Get highway alert details for a specific alert ID.",
} satisfies EndpointMeta<AlertByIdInput, Alert>;

const { fetch, useHook } = createFetchAndHook<AlertByIdInput, Alert>({
  api: wsdotHighwayAlertsApiMeta,
  endpoint: alertByIdMeta,
  getCacheStrategy: () =>
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    require("./shared/highwayAlerts.endpoints").highwayAlertsGroup
      .cacheStrategy,
});

/**
 * Fetch function for retrieving highway alert details for a specific alert ID
 */
export const fetchAlertById: FetchFactory<AlertByIdInput, Alert> = fetch;

/**
 * React Query hook for retrieving highway alert details for a specific alert ID
 */
export const useAlertById: HookFactory<AlertByIdInput, Alert> = useHook;
